import React, { useEffect, useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import FinancesTransactionSelectionTable from './controls/FinancesTransactionSelectionTable';

function FinancesMatchWithdrawals() {
  const [unmatchedDeposits, setUnmatchedDeposits] = useState([]);
  const [moveableToDeposits, setMoveableToDeposits] = useState([]);

  useEffect(() => {
    getUnmatchedDeposits();
    getMoveableToDeposits();
  }, []);

  const getUnmatchedDeposits = async () => {
    try {
      const response = await fetch('api/finances/getdepositsunmatched');
      const data = await response.json();
      setUnmatchedDeposits(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getMoveableToDeposits = async () => {
    try {
      const response = await fetch('api/finances/getmoveabletodeposits');
      const data = await response.json();
      setMoveableToDeposits(data);
    } catch (error) {
      console.error(error);
    }
  };

  const [open, setOpen] = useState('1');
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <div>
      <div>
        <h2>Match Deposits ({unmatchedDeposits?.reduce((total, symbolGroup) =>
            total + symbolGroup.assets.filter(t => t.type === "DEPOSIT").length, 0)})</h2>
        <br></br>
        <br></br>
        {unmatchedDeposits?.map((symbolGroup, index) => {
          const unmatchedDeposits = symbolGroup.assets.filter(t => t.type === "DEPOSIT").length;
          const unmatchedWithdrawals = symbolGroup.assets.filter(t => t.type === "WITHDRAWAL").length;
          return (
            <Accordion open={open} toggle={toggle} stayopen>
              <AccordionItem targetId={symbolGroup.symbol + index.toString()}>
                <AccordionHeader targetId={symbolGroup.symbol + index.toString()}>
                  <h5><b>[{symbolGroup.symbol}]</b> ({unmatchedWithdrawals}W, {unmatchedDeposits}D)</h5>
                </AccordionHeader>
                <AccordionBody accordionId={symbolGroup.symbol + index.toString()}>
                  <FinancesTransactionSelectionTable
                    transactions={symbolGroup?.assets}
                    matchUrl={'api/finances/matchdepositwithdrawal'}
                    getData={getUnmatchedDeposits} />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          );
        })}
        <br></br>
        <br></br>
      </div>
      <div>
        <h2>Move Withdrawn Lots to Deposit</h2>
        <br></br>
        <br></br>
        {moveableToDeposits?.map((depositGroup, index) => {
          var sourcesQuantity = depositGroup.sources?.reduce((total, source) => total + source.quantity, 0);
          return (
            <Accordion open={open} toggle={toggle} stayopen>
              <AccordionItem targetId={depositGroup.deposit.id + index.toString()}>
                <AccordionHeader targetId={depositGroup.deposit.id + index.toString()}>
                  <h5><b>[{depositGroup.deposit.symbol}] ({depositGroup.sources.length})</b> ({depositGroup.withdrawal.quantity} -> {depositGroup.deposit.quantity} : {sourcesQuantity}) ({depositGroup.withdrawal.account.friendlyName} -> {depositGroup.deposit.account.friendlyName})</h5>
                </AccordionHeader>
                <AccordionBody accordionId={depositGroup.deposit.id + index.toString()}>
                  <FinancesTransactionSelectionTable
                    transactions={[depositGroup.deposit, depositGroup.withdrawal, ...(depositGroup.sources || [])]}
                    matchUrl={'api/finances/matchsourcestodeposit'}
                    getData={getMoveableToDeposits} />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
}

export default FinancesMatchWithdrawals;